import { render, staticRenderFns } from "./SubmmissionsDetails.vue?vue&type=template&id=0e8266bb"
import script from "./SubmmissionsDetails.vue?vue&type=script&lang=js"
export * from "./SubmmissionsDetails.vue?vue&type=script&lang=js"
import style0 from "./SubmmissionsDetails.vue?vue&type=style&index=0&id=0e8266bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports